import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=da4b9934&scoped=true&"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuGroup.vue?vue&type=style&index=0&id=da4b9934&scoped=true&lang=css&"
import style1 from "./VerticalNavMenuGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4b9934",
  null
  
)

export default component.exports